import { BaseApiUrl } from '../../../configVariables';
import { ConversationStatusEntity } from '../../../model/ConversationStatusEntity';
import apiClient from '../../../utils/apiClient';

const statusesUrl = `${BaseApiUrl}/appsettings/conversationStatuses`;

export const fetchConversationStatuses = async (): Promise<ConversationStatusEntity[]> =>
    (await apiClient.get<ConversationStatusEntity[]>(statusesUrl)).data;

export const saveConversationStatus = async (
    status: Pick<ConversationStatusEntity, 'rowKey' | 'title' | 'colour' | 'statusPriority' | 'isDefault' | 'isInProgress' | 'isAwaitingResponse' | 'pauseHandlingTime' | 'isAutoGenerated'>
): Promise<ConversationStatusEntity> =>
    (await apiClient.post<ConversationStatusEntity, typeof status>(statusesUrl, status)).data;

export const deleteConversationStatus = async (rowKey: string): Promise<void> => {
    await apiClient.delete(`${statusesUrl}/${encodeURIComponent(rowKey)}`);
};
